import { render, staticRenderFns } from "./GlobalSearchInputModal.vue?vue&type=template&id=157af350"
import script from "./GlobalSearchInputModal.vue?vue&type=script&lang=js"
export * from "./GlobalSearchInputModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports